// import AddBoxIcon from '@mui/icons-material/AddBox';
// import PaymentIcon from '@mui/icons-material/Payment';
// import QrCodeIcon from '@mui/icons-material/QrCode';

import { PATH } from '~/constants/route-path';
import { isMobileResolution } from '~/utils/common';

// export function renderSidebarIcon(index) {
//   switch (index) {
//     case 0:
//       return <AddBoxIcon />;
//     case 1:
//       return <QrCodeIcon />;
//     case 2:
//       return <PaymentIcon />;
//     default:
//       <></>;
//   }
// }
//
// export function isSidebarVisible(routePath) {
//   if (routePath.includes('/s/')) return;
//
//   return ![
//     PATH.LOGIN,
//     PATH.CONFIRMATION,
//     PATH.PAYMENTS.CHECKOUT,
//     PATH.UNAUTH.MAIN,
//     PATH.TOS,
//     PATH.UNAUTH.PRIVACY_POLICY,
//     PATH.FACEBOOK_LOGIN,
//   ].includes(routePath);
// }
//
// export function isShowStepper(routePath) {
//   return ![PATH.QR.CREATE].includes(routePath);
// }

export const sidebarService = {
  getRoutesName: () => {
    if (isMobileResolution) {
      //phone names
    }

    //TODO: delete slice after get ui for another pages
    return sidebarService.names;
  },
  names: [
    { name: 'login', path: PATH.LOGIN },
    { name: 'signUp', path: PATH.SIGN_UP },
    { name: 'planPrice', path: PATH.UNAUTH.PRICES_AND_PLANS },
    { name: 'faq', path: PATH.UNAUTH.FAQ },
    // { name: 'api', path: '/payments' },
    // { name: 'resources', path: '/payments' },
  ],
};
